import { useController, ApplicationView } from '@aha-app/mvc';
import React, { useEffect, useRef } from 'react';
import CommonActionsGroup from './CommonActionsGroup';
import ExtensionActionsGroup from './ExtensionActionsGroup';
import SelectionController from './SelectionController';

interface Props {
  menuRef?: React.MutableRefObject<HTMLAhaMenuContentElement | undefined>;
  menuStyle?: React.CSSProperties;
  open?: boolean;
  id?: string;
}

const SelectionMenu: React.FC<Props> = ({ menuRef, menuStyle, open, id }) => {
  const controller = useController(SelectionController);
  const { customActionRender, customActionRenderPosition } = controller;
  const { actions } = controller.state.contextMenu;

  const internalMenuRef = useRef<HTMLAhaMenuContentElement>();

  useEffect(() => {
    internalMenuRef.current?.showPopover();
  }, []);

  return (
    <aha-menu-content
      // @ts-ignore refs on WCs
      ref={el => {
        if (menuRef) {
          menuRef.current = el;
        }

        internalMenuRef.current = el;
      }}
      style={menuStyle}
      open={open}
      id={id}
      popover='manual'
    >
      {customActionRender && customActionRenderPosition === 'top'
        ? customActionRender()
        : null}
      {actions.map((group, i) =>
        group.type === 'extension' ? (
          <ExtensionActionsGroup key={`group-${i}`} actions={group.actions} />
        ) : (
          <CommonActionsGroup key={`group-${i}`} actions={group.actions} />
        )
      )}
      {customActionRender && customActionRenderPosition === 'bottom'
        ? customActionRender()
        : null}
    </aha-menu-content>
  );
};

export default ApplicationView(SelectionMenu);
